export default "__VITE_ASSET__e764c76e__"